// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "./store/index";
import Vant from "vant";
import {Lazyload} from "vant";
import "vant/lib/index.css";
import "@/assets/js/rem";
// 引入 Tailwind CSS


import Storage from "vue-ls";
import api from "../utils/api";

import ECharts from "vue-echarts";
import {use} from "echarts/core";

import {CanvasRenderer} from "echarts/renderers";
import {BarChart} from "echarts/charts";
import {GridComponent, TooltipComponent} from "echarts/components";

use([CanvasRenderer, BarChart, GridComponent, TooltipComponent]);

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

// 全局注册组件（也可以使用局部注册）
Vue.component("v-chart", ECharts);

import {install} from "vs-tree";
import "vs-tree/dist/vs-tree.css";

Vue.use(install);

import vRow from "@/components/row/index.vue";
import vRowItem from "@/components/row/rowItem.vue";

import uploadImage from "@/components/upload/uploadImage";

import Readmore from "vue-readmore-readless";

Vue.prototype.$getVX = async () => {
    const {result} = await api.get("/weixin/createJsapiSignature", {
        url: window.location.href
    });

    wx.config({
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: result.appId, // 必填，公众号的唯一标识
        timestamp: result.timestamp, // 必填，生成签名的时间戳
        nonceStr: result.nonceStr, // 必填，生成签名的随机串
        signature: result.signature, // 必填，签名
        jsApiList: [
            "openLocation",
            "chooseImage",
            "previewImage",
            "uploadImage",
            "downloadImage",
            "chooseWXPay",
            "updateAppMessageShareData",
            "updateTimelineShareData"
        ] // 必填，需要使用的JS接口列表
    });

    return wx;
};

Vue.use(Readmore);

import evaking from "evaking";

import * as echarts from "echarts";
import "echarts-liquidfill";

Vue.prototype.$echarts = echarts;

Vue.use(Lazyload, {
    lazyComponent: true
});

Vue.component("vRow", vRow);
Vue.component("vRowItem", vRowItem);
Vue.component("uploadImage", uploadImage);

Vue.prototype.$api = api;

Vue.use(Vant);

Vue.config.productionTip = false;

Vue.prototype.$baseURL = process.env.baseUrl;

Vue.prototype.$go = url => {
    router.push(url);
};

Vue.prototype.$href = url => {
    location.href = location.origin + url;
};

Vue.prototype.$device = () => {
    var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
            /(?:iPad|PlayBook)/.test(ua) ||
            (isAndroid && !/(?:Mobile)/.test(ua)) ||
            (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
};

Vue.prototype.$baseUrl = process.env.ROOT_API;

Vue.prototype.$isLogin = () => {
    let token = Vue.ls.get("Access-Token");

    if (!token) {
        let service = `${window.location.origin}/pages/login/index?service=${window.location.href}`;

        let callback = `${
            process.env.baseUrl
        }/weixin/authorize?service=${Base64.encode(service)}`;

        window.location.href = callback;
    }
};

Vue.prototype.$toPrice = price => {
    if (price || price === 0) {
        return parseFloat(evaking.number_format(price.toFixed(2), 2)).toFixed(2);
    }
    return "";
};

import wx from "jweixin-npm";

Vue.prototype.$getVX = async () => {
    const {result} = await api.get("/weixin/createJsapiSignature", {
        url: window.location.href
    });

    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: result.appId, // 必填，公众号的唯一标识
        timestamp: result.timestamp, // 必填，生成签名的时间戳
        nonceStr: result.nonceStr, // 必填，生成签名的随机串
        signature: result.signature, // 必填，签名
        jsApiList: [
            "openLocation",
            "chooseImage",
            "previewImage",
            "uploadImage",
            "downloadImage",
            "chooseWXPay",
            "updateAppMessageShareData"
        ] // 必填，需要使用的JS接口列表
    });

    return wx;
};

Vue.prototype.$getDictText = async (code, key) => {
    const {result} = await api.get(`/sys/dict/getDictText/${code}/${key}`);

    return result;
};

Vue.prototype.$href = url => {
    location.href = location.origin + url;
};

Vue.prototype.$HTMLDecode = html => {
    var reg = /<[^>]+>/g;
    if (reg.test(html)) {
        return html;
    }
    var temp = document.createElement("div");
    temp.innerHTML = html;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
};

Vue.use(Storage, {
    namespace: "ntm__", // key prefix
    name: "ls", // name variable Vue.[ls] or this.[$ls],
    storage: "local" // storage name session, local, memory
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    components: {App},
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js